import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';

export type LandingHeroProps = {
  eyebrow: string;
  title: React.ReactNode;
  lead: React.ReactNode;
  primaryQuoteLabel: string;
  /** Synlig text på primärknapp (standard: Begär offert) */
  primaryCtaLabel?: string;
  onPrimaryQuote: (label: string) => void;
  /** Optional secondary CTA (e.g. Begär offert when primary scrolls to products) */
  secondaryQuoteLabel?: string;
  secondaryCtaLabel?: string;
  onSecondaryQuote?: (label: string) => void;
  phoneHref: string;
  phoneDisplay: string;
  onPhoneClick?: () => void;
};

const LandingHero: React.FC<LandingHeroProps> = ({
  eyebrow,
  title,
  lead,
  primaryQuoteLabel,
  primaryCtaLabel = 'Begär offert',
  onPrimaryQuote,
  secondaryQuoteLabel,
  secondaryCtaLabel = 'Begär offert',
  onSecondaryQuote,
  phoneHref,
  phoneDisplay,
  onPhoneClick,
}) => (
  <div className="relative z-10 mb-16 text-center">
    <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-purple-400">{eyebrow}</p>
    <h1 className="mb-6 text-4xl font-bold md:text-5xl">
      <span className="text-white">{title}</span>
    </h1>
    <div className="mx-auto mb-8 max-w-3xl text-lg leading-relaxed text-slate-300 md:text-xl">{lead}</div>
    <div className="flex flex-col justify-center gap-4 sm:flex-row sm:flex-wrap">
      <button
        type="button"
        onClick={() => onPrimaryQuote(primaryQuoteLabel)}
        className="inline-flex items-center justify-center rounded-none bg-purple-600 px-8 py-3 font-medium text-white transition-colors duration-300 hover:bg-purple-700"
      >
        {primaryCtaLabel}
        <ArrowRight className="ml-2" size={18} aria-hidden />
      </button>
      {secondaryQuoteLabel && onSecondaryQuote ? (
        <button
          type="button"
          onClick={() => onSecondaryQuote(secondaryQuoteLabel)}
          className="inline-flex items-center justify-center rounded-none border-2 border-purple-500/70 bg-transparent px-8 py-3 font-medium text-purple-200 transition-colors duration-300 hover:border-purple-400 hover:bg-purple-950/40"
        >
          {secondaryCtaLabel}
        </button>
      ) : null}
      <a
        href={phoneHref}
        onClick={onPhoneClick}
        className="inline-flex items-center justify-center rounded-none border-2 border-purple-600 bg-white px-8 py-3 font-medium text-purple-600 transition-colors duration-300 hover:bg-gray-50"
      >
        <Phone className="mr-2" size={18} aria-hidden />
        {phoneDisplay}
      </a>
    </div>
  </div>
);

export default LandingHero;
